import { AdressSharedRepository } from '../../../../../shared/domain/repositories/AdressSharedRepository';
import { RequestStatus } from '../../../../../shared/types/RequestStatus';
import { UseContextNotifier } from '../../../../../shared/types/UseContextNotifier';
import { PostRepository } from '../../repositories/PostRepository';
import PostListState from './PostListState';

export default class PostListUsecase extends UseContextNotifier<PostListState> {
  postRepository: PostRepository;
  adressSharedRepository: AdressSharedRepository;

  constructor(
    state: PostListState = new PostListState(),
    setState: React.Dispatch<React.SetStateAction<PostListState>>,
    postRepository: PostRepository,
    adressSharedRepository: AdressSharedRepository
  ) {
    super(state, setState);
    this.postRepository = postRepository;
    this.adressSharedRepository = adressSharedRepository;
  }

  public async getRegions() {
    this.updateState({
      ...this.state,
      regionsRequestStatus: RequestStatus.loading()
    });

    let resp = await this.adressSharedRepository.getRegions();

    resp.handle({
      onSuccess: data => {
        this.updateState({
          ...this.state,
          regionsRequestStatus: RequestStatus.succeeded(data)
        });
      },
      onFailure: error => {
        this.updateState({
          ...this.state,
          regionsRequestStatus: RequestStatus.failed(error)
        });
      }
    });
  }

  public async getPostList() {
    this.updateState({
      ...this.state,
      postsRequestStatus: RequestStatus.loading()
    });

    let resp = await this.postRepository.getPosts(this.state.queryParams);

    resp.handle({
      onSuccess: data => {
        this.updateState({
          ...this.state,
          postsRequestStatus: RequestStatus.succeeded(data)
        });
      },
      onFailure: error => {
        this.updateState({
          ...this.state,
          postsRequestStatus: RequestStatus.failed(error)
        });
      }
    });
  }

  public setSearch(search: string) {
    this.state.queryParams.search = search;

    this.updateState({
      ...this.state,
      queryParams: {
        ...this.state.queryParams,
        search: search
      }
    });
  }

  public setRegion(region: string) {
    this.state.queryParams.region = region;

    this.updateState({
      ...this.state,
      queryParams: {
        ...this.state.queryParams,
        region: region
      }
    });
  }

  public setAuthors(authors: string) {
    this.state.queryParams.authors = authors;

    this.updateState({
      ...this.state,
      queryParams: {
        ...this.state.queryParams,
        authors: authors
      }
    });
  }

  public setDate(date: string) {
    this.state.queryParams.date = date;

    this.updateState({
      ...this.state,
      queryParams: {
        ...this.state.queryParams,
        date: date
      }
    });
  }
}
